export default {
  name: 'fdc-panel',
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    type: {
      type: String,
      default: 'Normal',
      required: false
    },
    useHeader: {
      type: Boolean,
      default: true
    },
    useIcon: {
      type: Boolean,
      default: false
    },
    iconName: {
      type: String,
      default: ''
    },
    useFooter: {
      type: Boolean,
      default: false
    },
    multiRowHeader: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    usePin: {
      type: Boolean,
      default: false
    },
    payload: {
      type: [Object, Array, String, Number, Boolean],
      default () {
        return {}
      }
    }
  },
  mounted () {

  }
}
